import AddAlertIcon from '@mui/icons-material/AddAlert';
import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import { ModalName } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import { useStyles } from './AnnouncementButton.styles';

export const AnnouncementButton: FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isCurrentUserAdmin = useSelector(currentTournamentSelector.isCurrentUserAdmin);

  const onClickHandler = useCallback(() => {
    dispatch(modalsReducers.openModal({ name: ModalName.CreateAnnouncement }));
  }, [dispatch]);

  if (!isCurrentUserAdmin) {
    return null;
  }

  if (isLargeScreen) {
    return (
      <Button
        size="medium"
        onClick={onClickHandler}
        className={classes.announcementButton}
        startIcon={<AddAlertIcon fontSize="medium" />}
      >
        Add Announce
      </Button>
    );
  }

  return (
    <IconButton aria-label="share" onClick={onClickHandler}>
      <AddAlertIcon fontSize="medium" />
    </IconButton>
  );
};
